import React, { useEffect, useMemo, useRef, useState } from 'react'
import './Card.scss'
import { SECTIONS } from '../PlayerSection/PlayerSection'
import CardQuickActions, { ContextMenu, RightClickMenuWrapper } from './CardQuickActions'
import CardCounters from './CardCounters'
import { Button, Form } from 'react-bootstrap'
import { useGameContext } from '../../Commons/GameContext'
import { ACTION_MODES } from '../ActionMode'
import { IMG, isCardHidden, swapHideOrRevealCard } from '../../Commons/Functions'
import { v4 as uuidv4 } from 'uuid';

const CLICK_HOLD_DELAY = 200;

export function Card(props) {
    const [cardPos, setCardPos] = useState({ top: 0, left: 0 })
    const cardRef = useRef(null)
    const [isDragged, setIsDragged] = useState(false)
    const isDraggedRef = useRef(false)
    const [isMouseOver, setIsMouseOver] = useState(false)
    const clickTimeRef = useRef(false)
    const cardDraggedSize = useRef({ width: 0, height: 0 })
    const { cardSize, gameData } = useGameContext()
    const draggedCardMovementRef = useRef({ x: 0, y: 0, xValues: [], yValues: [] })
    const [draggedCardMovement, setDraggedCardMovement] = useState(draggedCardMovementRef.current)
    const [clickInfo, setClickInfo] = useState("")
    const [keyPressed, setKeyPressed] = useState(false)
    const [hovered, setHovered] = useState(false)

    const [menuVisible, setMenuVisible] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

    let card = props.card
    useEffect(() => {
        const handleKeyDown = (e) => {
            setKeyPressed(e.key)
        };

        const handleKeyUp = (e) => {
            setKeyPressed(false)
        };
        if (props.cardDraggedRef.current == props.card && props.card.createDraggedEvent !== true) {
            isDraggedRef.current = true
            onPointerDown()
        }

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);

        return (() => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        })
    }, [])

    useEffect(() => {
        if (isDragged) {
            if (keyPressed === "i") {
                card.isSpun = !card.isSpun
                props.repositionCards()
            } else if (keyPressed === "z") {
                swapHideOrRevealCard(card, props.playerId, props.opponentIds)
                props.repositionCards()
                if (Object.keys(card.hiddenTo).length == 0) {
                    props.sendToHistory("Revealed", card)
                } else {
                    props.sendToHistory("Hid a card")
                }
            }
        }
    }, [keyPressed])

    useEffect(() => {
        cardDraggedSize.current = { width: 30 * 0.7 * cardSize.vh, height: 30 * cardSize.vh }
    }, [cardSize.vh])

    useEffect(() => {
        const mode = props.currentActionMode
        let newClickInfo = ""

        if (props.isOpponentCard) {
            newClickInfo = "Ping"
        }

        if (mode) {
            // OPPONENT CAN DO
            if (mode.action == ACTION_MODES.LINK_TO) {
                newClickInfo = "Target"
            } else if (mode.action == ACTION_MODES.GROUP) {
                if (props.card.grouppedToId) {
                    newClickInfo = ""
                } else {
                    newClickInfo = "Group with"
                }
            } else if (mode.action == ACTION_MODES.PING || props.isOpponentCard) {
                newClickInfo = "Ping"
            } else {
                // PLAYER ONLY
                if (mode.action == ACTION_MODES.PRESENT) {
                    newClickInfo = "Forward"
                } else if (mode.action == ACTION_MODES.DISCARD) {
                    newClickInfo = "Discard"
                } else if (mode.action == ACTION_MODES.REMOVE) {
                    newClickInfo = "Remove"
                } else if (mode.action == ACTION_MODES.HAND) {
                    newClickInfo = "Hand"
                } else if (mode.action == ACTION_MODES.CARD_EFFECT) {
                    newClickInfo = "Add effect"
                } else if (mode.action == ACTION_MODES.SPIN) {
                    newClickInfo = "Invert"
                } else if (mode.action == ACTION_MODES.HIDE_REVEAL) {
                    newClickInfo = "Hide/Reveal"
                } else if (mode.action == ACTION_MODES.COUNTERS_PRIMARY_ADD) {
                    newClickInfo = "Primary +1"
                } else if (mode.action == ACTION_MODES.COUNTERS_SECONDARY_ADD) {
                    newClickInfo = "Secondary +1"
                } else {
                    if (props.card.position.section == SECTIONS.HAND) {
                        newClickInfo = "Play"
                    } else {
                        newClickInfo = props.card.isTapped ? "Untap" : "Tap"
                    }
                }
            }
        }
        if (clickInfo == "Play") {
            setTimeout(() => {
                setClickInfo(newClickInfo)
            }, 500)
        } else {
            setClickInfo(newClickInfo)
        }
    }, [props.currentActionMode.action, props.card.position.section, props.card.isTapped])

    function onPointerDown(e) {
        if (props.isOpponentCard) {
            props.clickCard();
            return;
        }
    
        if (e && e.pointerType === 'mouse' && e.button === 2) {
            e.preventDefault();
            setMenuPosition({ top: e.pageY, left: e.pageX });
            setMenuVisible(true);
            return;
        }
    
        const clickTime = Date.now();
        clickTimeRef.current = clickTime;
    
        let createDraggedEvent = false;
        if (card.createDraggedEvent) {
            createDraggedEvent = {
                pageY: 0 + card.createDraggedEvent.pageY,
                clientX: 0 + card.createDraggedEvent.clientX
            };
            card.createDraggedEvent = true;
        }
    
        let hasCleanedUp = false;
    
        const handleWindowMouseMove = (e) => {
            if (isDraggedRef.current) {
                setCardPos({ top: e.pageY, left: e.clientX });
    
                let rotateX = e.movementY * -1;
                let rotateY = e.movementX;
                let tmp = { ...draggedCardMovementRef.current };
                const scaleFactor = 0.2;
                const maxAngle = 20;
    
                tmp.xValues.push(rotateX);
                tmp.yValues.push(rotateY);
    
                const minMax = (val) => val > 0
                    ? Math.min(val / scaleFactor, maxAngle)
                    : Math.max(val / scaleFactor, -maxAngle);
    
                const getValFromArray = (arr) => minMax(arr.reduce((acc, v) => acc + v, 0) / arr.length);
    
                tmp.x = getValFromArray(tmp.xValues);
                tmp.y = getValFromArray(tmp.yValues);
                setDraggedCardMovement(tmp);
                draggedCardMovementRef.current = tmp;
    
                setTimeout(() => {
                    let tmp = { ...draggedCardMovementRef.current };
                    if (tmp.xValues.length > 0) {
                        tmp.xValues.shift();
                        tmp.yValues.shift();
                        tmp.x = getValFromArray(tmp.xValues);
                        tmp.y = getValFromArray(tmp.yValues);
                        setDraggedCardMovement(tmp);
                        draggedCardMovementRef.current = tmp;
                    }
                }, CLICK_HOLD_DELAY);
            }
        };
    
        const handleClickUp = () => {
            if (hasCleanedUp) return;
            hasCleanedUp = true;
    
            if (props.isOpponentCard) return;
    
            const now = Date.now();
            const wasClick = clickTimeRef.current && now - clickTimeRef.current < CLICK_HOLD_DELAY;
    
            if (!isDraggedRef.current && wasClick) {
                props.clickCard();
            } else if (isDraggedRef.current) {
                isDraggedRef.current = false;
                setIsDragged(false);
                setIsMouseOver(false);
                card.needUnMount = true
    
                setTimeout(() => {
                    props.cardDraggedRef.current = false;
                    const wasDraggedFromDeck = card.position.section === SECTIONS.DECK;
                    if (wasDraggedFromDeck) {
                        delete card.createDraggedEvent;
            
                        props.cards.splice(props.index, 1);
                        props.deck.push(card);
            
                        if ('requestIdleCallback' in window) {
                            requestIdleCallback(() => props.repositionCards());
                        } else {
                            setTimeout(props.repositionCards, 0);
                        }
                    }
                }, 0);
                // Put back anim later, block deck maybe ? deck card pointer event none ?
            }
    
            clickTimeRef.current = false;
    
            document.removeEventListener('pointermove', handleWindowMouseMove);
            document.removeEventListener('pointerup', handleClickUp);
        };
    
        document.addEventListener('pointermove', handleWindowMouseMove);
        document.addEventListener('pointerup', handleClickUp);
    
        setTimeout(() => {
            if (clickTimeRef.current === clickTime && !card.isTriggerEffect) {
                isDraggedRef.current = true;
                setIsDragged(true);
                props.setFocusedCard(false);
    
                if (e) {
                    setCardPos({ top: e.pageY, left: e.clientX });
                } else if (createDraggedEvent) {
                    setCardPos({ top: createDraggedEvent.pageY, left: createDraggedEvent.clientX });
                }
    
                props.cardDraggedRef.current = card;
                draggedCardMovementRef.current = { x: 0, y: 0, xValues: [], yValues: [] };
                setDraggedCardMovement(draggedCardMovementRef.current);
            }
        }, CLICK_HOLD_DELAY);
    }
    

    function moveCard(val) {
        let modifiedVal = val
        if (props.sectionData) {
            modifiedVal *= props.sectionData.alignment === "End" ? -1 : 1
        }
        const newIndex = card.position.index + modifiedVal
        if (newIndex > -1 && props.repositionCards) {
            card.position.index = newIndex
            props.repositionCards([card.position.section])
        }
    }

    function link() {
        props.setCurrentActionMode({
            action: ACTION_MODES.LINK_TO,
            actionData: {
                id: uuidv4(),
                fromCardName: card.cardData.name,
                fromSection: card.position.section,
                from: card.id,
                to: false,
                toSection: false,
                isFromQuickAction: true
            }
        })
    }

    let cardWidth = card.position.cardSize ? (card.isHorizontal ? card.position.cardSize.height : card.position.cardSize.width) : false
    let cardHeight = card.position.cardSize ? (card.isHorizontal ? card.position.cardSize.width : card.position.cardSize.height) : false
    let cardBorderRadius = card.position.cardSize ? card.position.cardSize.height / 25 : 1

    let posX = cardPos.left
    let posY = cardPos.top

    if (card.position.pos && !isDragged) {
        posX = card.position.pos.left
        posY = card.position.pos.top
    }
    if (isDragged) {
        cardWidth = 30 * 0.7
        cardHeight = 30
        posX -= cardWidth * cardSize.vh / 2
        posY -= cardHeight * cardSize.vh / 2
    }

    let angle = 0;
    let translateY = 0

    if (card.position.section === SECTIONS.HAND && !isDragged) {
        if (hovered) {
            posY -= 7 * cardSize.vh
        } else {
            const handSize = props.handSize !== undefined ? props.handSize : 7
            const i = card.position.index
            let maxAngle = Math.min(3 * handSize, 20); // total fan angle
            let ratio = i / (handSize - 1); // from 0 to 1
            if (handSize <= 1) {
                maxAngle = 0;
                ratio = 1;
            }
            angle = -maxAngle / 2 + ratio * maxAngle;

            // You can tweak the curve strength with this formula
            const curveStrength = Math.min(24 * handSize * (31 - maxAngle), 3000); // how "high" the arc is
            translateY = -Math.cos((angle * Math.PI) / 180) * curveStrength + curveStrength - 1.8 * cardSize.vh;
            translateY *= cardSize.vh / 10
        }
    }
    if (props.isOpponentCard) {
        //console.log("card rerendered")
    }
    //console.log(`Rendering card ${card.id} with angle ${angle} at`, card.position.pos)
    return (
        <div className={"game-card" + (isDragged ? " dragged" : "") + (card.isTapped ? " tapped" : "") + " " + card.position.section + (card.hiddenTo[props.playerId] === true ? " card-hidden-yes" : " card-hidden-no") + (card.isFlipped ? " card-flipped" : "") + (card.isHorizontal ? " card-horizontal" : "") + " reversed-index-" + card.position.reversedIndex + (props.isOpponentCard ? " opponent-card" : "") + (card.isPresented ? " presented" : "") + (card.isManaCostHightlight ? " mana-highlight" : "") + (card.isTriggerEffect ? " trigger-effect" : "") + (isMouseOver ? " hover" : "") + (props.currentActionMode.action === ACTION_MODES.NONE ? "" : " awaiting-action-mode") + (card.isSpun ? " spun" : "")}
            style={{
                zIndex: card.position.index + (card.position.section === SECTIONS.HAND ? 1000 : 0),
                transform: `translate(${posX}px, ${posY}px) rotateX(${isDragged ? draggedCardMovement.x : 0}deg) rotateY(${isDragged ? draggedCardMovement.y : 0}deg) rotateZ(${angle}deg) translateY(${translateY}px)`,
                width: cardWidth * cardSize.vh, height: cardHeight * cardSize.vh
            }}
            id={card.id}
            ref={cardRef}
            onContextMenu={(e) => {
                e.preventDefault();
            }}
            onPointerEnter={() => setHovered(!props.isOpponentCard)}
            onPointerLeave={() => setHovered(false)}
        >
            {card.isPresented && !isDragged && (<img src={require("../Assets/present-card.png")} className='position-absolute start-50 presented-image translate-middle pe-none' />)}

            <div className='card-images card-images-and-wrapper w-100 h-100 position-absolute top-0 start-0'
                style={{ borderRadius: cardBorderRadius + "vh" }}
                id={card.id + "-images"}
                onPointerEnter={() => {
                    if (!isDraggedRef.current) {
                        if (card.hiddenTo[props.playerId] !== true) {
                            props.setFocusedCard({
                                card: card,
                                position: card.position.pos
                            })
                        } else if (!props.isOpponentCard && props.gameOptions && !props.gameOptions.format.hideFacedDownCards) {
                            props.setFocusedCard({
                                card: card,
                                position: card.position.pos
                            })
                        }
                    }
                    if (card.position.section == SECTIONS.HAND && props.setHoverCardCost) {
                        props.setHoverCardCost(card.cardData.cost)
                    }
                    setIsMouseOver(true)
                }}
                onPointerLeave={() => {
                    props.setFocusedCard(false)
                    if (card.position.section == SECTIONS.HAND && props.setHoverCardCost) {
                        props.setHoverCardCost(0)
                    }
                    setIsMouseOver(false)
                }}
            >
                <div className="card-front-and-back w-100 h-100 position-absolute top-0 start-0" >
                    <div className='position-absolute top-0 start-0 w-100 h-100 sleeve pe-none'></div>
                    <IMG src={card.cardData.face.front.image} className='card-front w-100 h-100 position-absolute top-0 start-0' style={{ borderRadius: cardBorderRadius + "vh" }} />
                    {card.cardData.face.back && (<IMG src={card.cardData.face.back.image} className='card-back w-100 h-100 position-absolute top-0 start-0' style={{ borderRadius: cardBorderRadius + "vh" }} />)}
                    {card.notes && (<img className="notes-indicator position-absolute top-0 start-0 m-1" src={require('../Assets/notes.png')} />)}
                </div>
                <IMG src={gameData.cards.cardBack} className='card-hidden-back w-100 h-100 position-absolute top-0 start-0 pe-auto' style={{ borderRadius: cardBorderRadius + "vh" }} />
                {/*<div className='w-100 h-100 position-absolute top-0 start-0'
                    onPointerDown={onPointerDown}
                >
            </div>*/}
                <div className='card-click-info position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center' style={{ opacity: 0, borderRadius: cardBorderRadius + "vh" }}
                    onPointerDown={onPointerDown}
                >
                    <p>{clickInfo}</p>
                </div>
                <CardCounters
                    card={card}
                    repositionCards={props.repositionCards}
                    isHorizontal={props.card.isHorizontal}
                    isOpponentCard={props.isOpponentCard}
                    setIsTextInputFocused={props.setIsTextInputFocused}
                />
                {props.currentActionMode.action === ACTION_MODES.MOVE && !props.isOpponentCard && !card.grouppedToId && (
                    <div
                        className='card-move position-absolute top-0 start-0 h-100 w-100'
                        style={{ zIndex: 10000, borderRadius: cardBorderRadius + "vh" }}
                        onPointerEnter={() => props.setFocusedCard(false)}
                    >
                        <div className='position-absolute top-50 start-50'>
                            <div className='d-flex w-100 h-100 card-move-rotation-wrapper'>
                                <div className='w-100' onClick={() => {
                                    moveCard(-1.5)
                                }}><img className="w-25" src={require('../../Commons/Assets/Icons/return.png')} /></div>
                                <div className='w-100' onClick={() => {
                                    moveCard(1.5)
                                }}><img className="w-25" src={require('../../Commons/Assets/Icons/return.png')} style={{ rotate: "180deg" }} /></div>
                            </div>
                        </div>
                    </div>)}
                {card.isToken && (
                    <Form.Control
                        className='token-count position-absolute bottom-0 end-0'
                        type="number"
                        value={card.tokenCount}
                        readOnly={props.isOpponentCard}
                        onChange={(e) => {
                            if (props.repositionCards) {
                                card.tokenCount = e.target.value
                                props.repositionCards() // FAIRE MIEUX
                            }
                        }}
                    />
                )}
                {props.opponentIds && Object.keys(card.hiddenTo).length < props.opponentIds.length && !card.hiddenTo[props.playerId] && (<img className="card-revealed-indicator d-none position-absolute top-0 start-0" src={require('../Assets/card-visibility.png')} />)}
            </div>
            {
                !props.isOpponentCard && (
                    <div className='wrapper card-images-and-wrapper w-100 h-100 position-absolute top-0 start-0 pe-none'>
                        <Button style={card.position.section != SECTIONS.STACK || props.card.position.reversedIndex == 0 ? {} : { visibility: "hidden", pointerEvents: "none" }} className="d-flex link-button position-absolute start-0" onClick={() => link()}><img src={require('../Assets/cards-links.png')} /></Button>
                        <CardQuickActions
                            card={card}
                            deck={props.deckRef}
                            cards={props.cards}
                            index={props.index}
                            repositionCards={props.repositionCards}
                            setCurrentActionMode={props.setCurrentActionMode}
                            onClick={() => props.setFocusedCard(false)}
                            opponentIds={props.opponentIds}
                            opponentsData={props.opponentsData}
                            giveCardAtIndexTo={props.giveCardAtIndexTo}
                            moveCard={props.moveCard}
                            sendToHistory={props.sendToHistory}
                            playerId={props.playerId}
                            setIsTextInputFocused={props.setIsTextInputFocused}
                            show={menuVisible}
                            position={menuPosition}
                            onClose={() => setMenuVisible(false)}
                        />
                    </div>)
            }
        </div >
    )
}

function areEqual(prevProps, nextProps) {
    return prevProps.refreshCount === nextProps.refreshCount &&
        prevProps.currentActionMode.action === nextProps.currentActionMode.action &&
        prevProps.card.isTapped === nextProps.card.isTapped
}

export default React.memo(Card, areEqual);